import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const VIDEO_SRC = 'https://oss.bitfantasy.com.cn/video/brd-1080-ss.mp4';
const VIDEO_POSTER = 'https://readdy.ai/api/search-image?query=NIMO%20AI%20smart%20glasses%20brand%20film%20cinematic%20dark%20product%20showcase%20studio%20lighting%20premium%20technology%20minimalist%20black%20background%20soft%20gradient%20elegant%20wearable%20device%20high%20end%20commercial&width=1280&height=720&seq=nimo-native-poster-02&orientation=landscape';

export default function NativeVideoPlayer() {
  const { t } = useTranslation();
  const { ref: wrapRef, isVisible: wv } = useScrollAnimation(0.1);
  const [playing, setPlaying] = useState(false);

  return (
    <section id="nimo-video-section" className="w-full bg-[#0c0c0b] py-20 lg:py-28 overflow-hidden">
      <div
        ref={wrapRef as React.RefObject<HTMLDivElement>}
        className="max-w-6xl mx-auto px-6 lg:px-10"
      >
        {/* ── Section header ── */}
        <div
          className="text-center mb-12"
          style={{
            opacity: wv ? 1 : 0,
            transform: wv ? 'translateY(0)' : 'translateY(22px)',
            transition: 'opacity 0.9s ease 0ms, transform 0.9s cubic-bezier(0.16,1,0.3,1) 0ms',
          }}
        >
          <p className="font-label text-xs tracking-[0.35em] text-white/35 uppercase mb-4">
            Brand Film
          </p>
          <h2 className="font-zh-serif text-3xl md:text-4xl lg:text-5xl text-white font-light mb-4">
            {t('video_title')}
          </h2>
          <p className="text-white/45 text-sm md:text-base font-light tracking-wide">
            {t('video_subtitle')}
          </p>
        </div>

        {/* ── Player container ── */}
        <div
          className="relative w-full rounded-2xl overflow-hidden bg-black"
          style={{
            aspectRatio: '16/9',
            opacity: wv ? 1 : 0,
            transform: wv ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.97)',
            transition: 'opacity 1s ease 180ms, transform 1.1s cubic-bezier(0.16,1,0.3,1) 180ms',
          }}
        >
          {playing ? (
            /* 点击播放后才挂载 video，preload="auto" 直接下载播放 */
            <video
              width="100%"
              controls
              autoPlay
              playsInline
              preload="auto"
              className="absolute inset-0 w-full h-full object-contain bg-black"
              poster={VIDEO_POSTER}
            >
              <source src={VIDEO_SRC} type="video/mp4" />
              您的浏览器不支持 HTML5 视频播放。
            </video>
          ) : (
            /* 封面层：用户点击前不下载任何视频数据 */
            <div
              className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer group"
              onClick={() => setPlaying(true)}
            >
              {/* Dark background */}
              <div className="absolute inset-0 bg-[#0c0c0b]" />
              {/* Play button */}
              <button
                className="relative z-10 w-20 h-20 lg:w-24 lg:h-24 flex items-center justify-center rounded-full border border-white/40 bg-white/10 backdrop-blur-sm hover:bg-white/25 hover:border-white/70 transition-all duration-300 cursor-pointer"
                aria-label={t('video_play_label')}
              >
                <span className="w-20 h-20 lg:w-24 lg:h-24 flex items-center justify-center">
                  <i className="ri-play-fill text-3xl lg:text-4xl text-white ml-1" />
                </span>
                <span className="absolute inset-0 rounded-full border border-white/20 animate-ping opacity-40" />
              </button>
              <p className="relative z-10 mt-5 text-white/50 text-xs tracking-[0.2em] uppercase font-label">
                {t('video_play_label')}
              </p>
            </div>
          )}
        </div>

      </div>
    </section>
  );
}
